import { formatApiError } from './apiErrors';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

export function csrfToken() {
  const match = document.cookie.match(/(?:^|;\s*)csrf_token=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

// Same-origin credentialed fetch that echoes the CSRF cookie back as a header (double-submit pattern).
export function apiFetch(path, options = {}) {
  const headers = { ...(options.headers || {}) };
  const token = csrfToken();
  if (token && options.method && options.method !== 'GET') headers['X-CSRF-Token'] = token;
  return fetch(`${API_BASE}${path}`, { credentials: 'include', ...options, headers });
}

export async function apiJson(path, options) {
  const response = await apiFetch(path, options);
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(formatApiError(body.detail || 'Request failed'));
  return body;
}
